<script>
  import { companyName } from '$lib/utils/consts';

  const currentYear = new Date().getFullYear();
</script>

<span class="text-sm">
  © {currentYear === 2022 ? currentYear : `2022 - ${currentYear}`}
  <a href="/" class="ti-link">{companyName}</a>
  版权所有
</span>
